<div class="d-flex justify-content-between align-items-center" *ngIf="totalCount > 0">
  <span class="sub-text">Showing {{ startCount }} to {{ endCount }} of {{ totalCount }} records</span>

  <nav>
    <ul class="pagination pagination-sm mb-0">
      <!-- Previous -->
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link cursor-pointer" (click)="onPrev()" aria-label="Previous">Prev</a>
      </li>

      <!-- Page numbers -->
      @for (page of pages; track $index) {
        @if (page === '...') {
          <li class="page-item disabled">
            <span class="page-link">&hellip;</span>
          </li>
        } @else {
          <li class="page-item" [class.active]="page === currentPage">
            <a class="page-link cursor-pointer" (click)="goToPage(+page)">{{ page }}</a>
          </li>
        }
      }

      <!-- Next -->
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link cursor-pointer" (click)="onNext()" aria-label="Next">Next</a>
      </li>
    </ul>
  </nav>
</div>
